import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const MenuWrapper = styled.div<{
  top: number;
  left: number;
  hidden: boolean;
}>`
  top: ${({ top }) => `${top}px`};
  left: ${({ left }) => `${left}px`};
  transition: ${({ hidden }) => (hidden ? 'none' : '200ms')};
  transition-timing-function: ease;
  transition-property: opacity, transform;
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  transform: ${({ hidden }) =>
    `translateY(${hidden ? 20 : 0}px) scale(${hidden ? 0.7 : 1})`};
  height: 32px;
  white-space: nowrap;
  display: flex;
  padding: 4px;
  position: absolute;
  z-index: 1500;
  background-color: ${theme.color.white};
  margin-top: -6px;
  border-radius: 4px;
  box-shadow: 0px 6px 10px ${theme.color.grey14},
    0px 1px 18px rgba(0, 0, 0, 0.12), ${theme.shadow.low};
  & > * + * {
    margin-left: 4px;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: calc(100% - 0.5em);
  margin-top: 0.25em;
  margin-bottom: 0.25em;
  display: block;
  background: ${theme.color.grey14};
  margin-left: 0.5em;
  margin-right: 0.5em;
`;
